import type { OptionsMap } from '~/types/elementsUi'
import type { SafeNullableBoolean } from '~/types/utils'
import type { FAIconName } from '#shared/types/generated-icons'

export const ENGLISH_MODE_CLASS = 'en'

export const selectMiscOption = 'misc' as const
export const nullableBooleanIcons: Record<SafeNullableBoolean, FAIconName> = {
  0: 'fa-thumbs-down',
  1: 'fa-thumbs-up',
  2: 'fa-file-circle-question'
}
export const weekDaysOptions = computed<OptionsMap<string>[]>(() => {
  const localeIsDutch = useLocaleStore().localeIsDutch

  return [
    {
      id: '0',
      name: localeIsDutch ? 'Maandag' : 'Monday'
    },
    {
      id: '1',
      name: localeIsDutch ? 'Dinsdag' : 'Tuesday'
    },
    {
      id: '2',
      name: localeIsDutch ? 'Woensdag' : 'Wednesday'
    },
    {
      id: '3',
      name: localeIsDutch ? 'Donderdag' : 'Thursday'
    },
    {
      id: '4',
      name: localeIsDutch ? 'Vrijdag' : 'Friday'
    },
    {
      id: '5',
      name: localeIsDutch ? 'Zaterdag' : 'Saturday'
    },
    {
      id: '6',
      name: localeIsDutch ? 'Zondag' : 'Sunday'
    }
  ]
})
